import angular from 'angular';
import CaseModalComponent from './case.modal.component';
export default angular.module('invision.customercare.caseModal', []).component('caseModal', CaseModalComponent).name;